import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../../../../form/TextField';

export const EmailInputComponent = React.forwardRef(({
  value,
  onChange,
  onBlur,
  error,
  errorMessage,
  isPcg,
}, ref) => (
  <TextField
    id='in-page-lead-form-email-input'
    label='Email'
    ref={ref}
    name='email'
    value={value}
    error={error}
    errorMessage={errorMessage}
    onChange={onChange}
    onBlur={onBlur}
    required={true}
    customTheme={'leads'}
    maxLength={200}
    isPcg={isPcg} />
));

EmailInputComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default EmailInputComponent;
